import { use } from 'react';

import { SlotsContext } from '~/components/providers/slots-provider/context';
import { cn } from '~/utils/cn';

export function useSlot<Props extends React.PropsWithChildren & { className?: string }>(
  props: Props & { slot?: string },
  defaultSlot?: string
): Props | null {
  const slot = props.slot ?? defaultSlot;

  if (!slot) {
    return props;
  }

  const slots = use(SlotsContext);

  if (!slots) {
    throw new Error('useSlot must be used within a SlotsProvider');
  }

  if (!slots[slot]) {
    console.warn(`useSlot: no "${slot}" slot found`);
    return props;
  }

  let className = props.className;
  if (typeof slots[slot] === 'object' && 'className' in slots[slot]) {
    className = cn(slots[slot].className as string, props.className);
  }

  return {
    // TODO: think about finding a way to override template props (props from config) by SlotContext,
    // since in general, props should have highest precedence
    ...props,
    ...slots[slot],
    ...(className && { className }),
  } as Props;
}
